import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import ReactGA from 'react-ga';

import Routes from 'Routes';
import createStore from 'store/createStore';

import registerServiceWorker from 'registerServiceWorker';

import { GA_KEY } from './config';
import './static/styles/index.scss';

export const { store, history } = createStore();
ReactGA.initialize(GA_KEY);

history.listen((location) => {
  ReactGA.pageview(location.pathname);
});

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Routes />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);
if (process.env.NODE_ENV === 'production') {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    // eslint-disable-next-line
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

// Register serviceWorker
// ------------------------------------

if (process.env.NODE_ENV === 'production') {
  registerServiceWorker();
}

// https://carsapp-api.herokuapp.com/
// http://localhost:8080/

// "http://ec2-18-218-142-67.us-east-2.compute.amazonaws.com/"

// http://instantcarloanapproval.ca/



// WEBPACK FOOTER //
// ./src/index.js